"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Button, _Component);

  function Button() {
    (0, _classCallCheck3.default)(this, Button);
    return (0, _possibleConstructorReturn3.default)(this, (Button.__proto__ || (0, _getPrototypeOf2.default)(Button)).apply(this, arguments));
  }

  (0, _createClass3.default)(Button, [{
    key: "render",
    value: function render() {
      var className = "button";
      if (this.props.additionalClasses) {
        className += " " + this.props.additionalClasses;
      }

      if (this.props.inverse) {
        return _react2.default.createElement(
          "div",
          { className: "button-container" },
          _react2.default.createElement(
            "div",
            { className: "button-cornered-inverse-container", onClick: this.props.onClick },
            _react2.default.createElement(
              "svg",
              { className: "button-cornered-inverse" },
              _react2.default.createElement("polygon", { points: "18,1 205,1 222,18 222,44 205,61 18,61 1,44 1,18" })
            ),
            _react2.default.createElement(
              "span",
              { className: "button-cornered-inverse-text" },
              this.props.text,
              _react2.default.createElement("img", { src: "/img/maaporssi-arrow-right-white.png" })
            )
          )
        );
      }
      return _react2.default.createElement(
        "div",
        { className: "button-container" },
        _react2.default.createElement(
          "button",
          (0, _extends3.default)({ className: className, onClick: this.props.onClick }, this.props),
          _react2.default.createElement(
            "span",
            { className: "button-text" },
            this.props.text
          )
        ),
        this.props.children
      );
    }
  }]);
  return Button;
}(_react.Component), _class.propTypes = {
  text: _react.PropTypes.string.isRequired,
  additionalClasses: _react.PropTypes.string,
  inverse: _react.PropTypes.bool,
  children: _react.PropTypes.object,
  onClick: _react.PropTypes.func.isRequired
}, _temp);
exports.default = Button;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/form/Button.js
 ** module id = 33
 ** module chunks = 0
 **/